<template>
  <div class="ls-provider-info--leads">
    <h1 class="ls-provider-info--leads-top-title">My Projects</h1>
    <div class="ls-provider-info--service-name-wrapper">
      <div>
        <div
          v-for="(service, idx) in customerLead.services"
          :key="service.id"
          :class="['ls-provider-info--service-name', { 'new-hired-flow': showNewHiredFlow }]"
        >
          {{ `${service.name}${idx !== customerLead.services.length - 1 ? ',' : ''}` }}
        </div>
      </div>
      <LsButton
        v-if="showNewHiredFlow && showHireProButton"
        text="hire pro"
        track-id="ls_provider_info-hire_pro"
        @click="openLeadsHiredFlowModal"
      />
      <LsButton
        v-else-if="customerLead.awaiting_review"
        text="review pro"
        track-id="ls_provider_info-review"
        @click="openReviewLeadModal"
      />
    </div>

    <div
      v-for="(contact, i) in getActiveCustomerLeadsContacts"
      :key="contact.id"
      class="ls-provider-info--leads-card-wrapper"
    >
      <div><LsProviderInfoCardMore v-bind="contact" :property="property" /></div>
      <div :class="['ls-provider-info--cta-wrapper', { 'new-hired-flow': showNewHiredFlow }]">
        <LsButton
          v-if="!showNewHiredFlow && showHireProButton"
          text="hire pro"
          track-id="ls_provider_info-hire_pro"
          @click="
            openLeadsConfirmHiredModal({
              contractor: contact.contractor,
              customerLeadId: customerLead.id,
              propertyId: property.id,
              contactId: contact.id,
            })
          "
        />
        <LsButton
          v-if="contact.status !== 'closed'"
          :class="['ls-provider-info--message', { 'new-hired-flow': showNewHiredFlow }]"
          text="MESSAGE"
          :icon="contact.is_unread ? 'circlepulse' : null"
          bg-color="primary-light"
          text-color="primary"
          :test-id="`ls_provider_info_message_${i}`"
          track-id="ls_provider_info-message_pro"
          :min-width="false"
          @click="
            $router.push({
              name: 'leadsInbox',
              params: {
                property_id: property.id,
                customer_lead_id: customerLead.id,
                contact_id: contact.id,
              },
            })
          "
        />
      </div>
    </div>
    <h1 v-if="showHeading" class="ls-provider-info--lower-heading">My Scheduled Services</h1>
  </div>
</template>

<script>
import VueTypes from 'vue-types';
import _ from 'lodash';
import { lsModalService } from 'ls-vue-common';
import LsProviderInfoCardMore from '../LsProviderInfoCardMore/LsProviderInfoCardMore.vue';
import { LeadsHiredFlowModal, LeadsConfirmHiredModal, ReviewLeadModal } from '@/modals';
import { LsButton } from '@/components/common';

export default {
  name: 'LsProviderInfo',
  components: { LsProviderInfoCardMore, LsButton },
  props: {
    showHeading: VueTypes.bool.isRequired,
    showNewHiredFlow: VueTypes.bool.def(false),
    property: VueTypes.shape({
      id: VueTypes.number.isRequired,
      customer_leads: VueTypes.arrayOf(
        VueTypes.shape({
          id: VueTypes.number.isRequired,
          status: VueTypes.string.isRequired,
          services: VueTypes.arrayOf(
            VueTypes.shape({
              name: VueTypes.string.isRequired,
            }).isRequired.loose
          ),
          customer_lead_contacts: VueTypes.arrayOf(
            VueTypes.shape({
              id: VueTypes.number.isRequired,
              status: VueTypes.string.isRequired,
            }).isRequired.loose
          ).isRequired,
        }).isRequired.loose
      ).isRequired,
    }).isRequired.loose,
  },
  computed: {
    customerLead() {
      return this.property.customer_leads[0];
    },
    showHireProButton() {
      return this.customerLead.status !== 'hired';
    },
    getActiveCustomerLeadsContacts() {
      const allContacts = this.customerLead.customer_lead_contacts;
      const activeContacts = _.filter(allContacts, (lead) => {
        return lead.status !== 'closed';
      });

      return activeContacts;
    },
    getHiredCustomerLeadContact() {
      const allContacts = this.customerLead.customer_lead_contacts;
      return _.find(allContacts, (contact) => {
        return contact.status === 'hired';
      });
    },
  },
  methods: {
    openLeadsConfirmHiredModal({ contractor, customerLeadId, contactId, propertyId }) {
      lsModalService.open({
        parent: this,
        component: LeadsConfirmHiredModal,
        props: {
          contractor,
          customerLeadId,
          contactId,
          propertyId,
        },
      });
    },
    openLeadsHiredFlowModal() {
      const { customerLead, property } = this;

      lsModalService.open({
        parent: this,
        component: LeadsHiredFlowModal,
        width: 760,
        props: {
          customerLead: customerLead,
          customerLeadId: customerLead.id,
          propertyId: property.id,
          showWhichProView: true,
        },
      });
    },
    openReviewLeadModal() {
      const { first_name } = this.getHiredCustomerLeadContact.contractor.user;
      const { customerLead, property } = this;

      lsModalService.open({
        parent: this,
        component: ReviewLeadModal,
        width: 760,
        props: {
          customerLead,
          propertyId: property.id,
          firstName: first_name,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ls-provider-info--leads {
  margin-bottom: 20px;

  .ls-provider-info--leads-top-title {
    margin-bottom: 20px;
  }

  .ls-provider-info--service-name-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;

    @media (max-width: $desktop) {
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;

      button {
        margin-top: 15px;
      }
    }
  }

  .ls-provider-info--service-name {
    font-weight: 700;
    font-size: 16px;
    color: $primary;
    display: inline;

    &.new-hired-flow {
      display: flex;
      flex-direction: column;

      @media (max-width: $desktop) {
        display: inline;
        text-align: left;
      }
    }
  }

  .ls-provider-info--leads-card-wrapper {
    margin-top: 5px;
    border-top: 1px solid $primary-light;
    padding: 15px 0;
    width: 100%;
    display: flex;
    justify-content: space-between;

    @media (max-width: $desktop) {
      flex-direction: column;
    }

    &:last-of-type {
      border-bottom: 1px solid $primary-light;
    }
  }

  .ls-provider-info--cta-wrapper {
    display: flex;
    flex-direction: column;

    @media (max-width: $desktop) {
      margin-top: 35px;
    }

    .ls-provider-info--message {
      margin-top: 10px;

      &.new-hired-flow {
        margin-top: 0px;
      }
    }
  }

  .ls-provider-info--lower-heading {
    margin-top: 20px;
  }
}
.themed-app {
  .ls-provider-info--leads {
    .ls-provider-info--service-name {
      color: $theme-color-primary;
    }
    .ls-provider-info--leads-card-wrapper {
      border-top: 1px solid $theme-color-primary-light;
      &:last-of-type {
        border-bottom: 1px solid $theme-color-primary-light;
      }
    }
  }
}
</style>

<style lang="scss">
.ls-provider-info--message {
  svg {
    width: 13px;
    height: 13px;
  }
  min-width: 120px;
  .add-right-padding {
    padding-right: 3px;
  }
}
</style>
